import { render, staticRenderFns } from "./DetectionDetailRequestLayout_.vue?vue&type=template&id=261d7004&scoped=true"
import script from "./DetectionDetailRequestLayout_.vue?vue&type=script&lang=js"
export * from "./DetectionDetailRequestLayout_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d7004",
  null
  
)

export default component.exports